import http from '@/assets/js/http'
import {
  baseMDReadiness
} from '@/assets/js/base-url.js'


export default {
  namespaced: true,
  state: {
    check_list: [],
    check_log: {},
    action_list: [],
    final_summary_list: [],
    summary_by_status: [],
    cal: {},
    monitor_config: [],
    monitor_code: []
  },
  mutations: {
    setCheckList(state, newVal) {
      state.check_list = newVal
    },
    setCheckLog(state, newVal) {
      state.check_log = newVal
    },
    setActionList(state, newVal) {
      state.action_list = newVal
    },
    setFinalSummaryList(state, newVal) {
      state.final_summary_list = newVal
    },
    setSummaryByStatus(state, newVal) {
      state.summary_by_status = newVal
    },
    setCal(state, newVal) {
      state.cal = newVal
    },
    setMonitorConfig(state, newVal) {
      state.monitor_config = newVal
    },
    setMonitorCode(state, newVal) {
      state.monitor_code = newVal
    },
    deleteMonitorCode(state, payload) {
      const {
        product_code,
        monitor_id
      } = payload;
      const recordIndex = state.monitor_code.findIndex(item => item.product_code == product_code && item.monitor == monitor_id)
      state.monitor_code.splice(recordIndex, 1);
    }
  },
  actions: {
    getReadiness(ctx, params) {
      let url =
        `${baseMDReadiness}/mdchecking/` + params.types;
      http.get(url, {}).then(resp => {
        ctx.commit('setCheckList', resp.data)
      });
    },
    getLog(ctx, params) {
      let url =
        `${baseMDReadiness}/mdlogs/` + params.types;
      http.get(url, {}).then(resp => {
        ctx.commit('setCheckLog', resp.data)
        ctx.dispatch('getCal', {
          types: params.types,
          cal_id: resp.data.cal_id
        });
        ctx.dispatch('getSummaryByStatus', {
          types: params.types,
          cal_id: resp.data.cal_id
        });
      });
    },
    getAction(ctx, params) {
      let url =
        `${baseMDReadiness}/mdaction`;
      http.get(url, {}).then(resp => {
        ctx.commit('setActionList', resp.data)
      });
    },
    getFinalSummary(ctx, params) {
      let url =
        `${baseMDReadiness}/mdfinalsummary/` + params.types;
      http.get(url, {}).then(resp => {
        ctx.commit('setFinalSummaryList', resp.data)
      });
    },
    getSummaryByStatus(ctx, params) {
      let url =
        `${baseMDReadiness}/mdsummarybystatus/` + params.types + "/" + params.cal_id;
      http.get(url, {}).then(resp => {
        ctx.commit('setSummaryByStatus', resp.data)
      });
    },
    getCal(ctx, params) {
      let url =
        `${baseMDReadiness}/mdcalendar/` + params.types + "/" + params.cal_id;
      http.get(url, {}).then(resp => {
        ctx.commit('setCal', resp.data)
      });
    },
    getReport(ctx, params) {
      let url =
        `${baseMDReadiness}/report/` + params.types + "/" + params.id + "/" + params.dtype;
      return http.get(url, {}).then(resp => {
        const blob = new Blob([resp.data], {
          type: 'application/vnd.ms-excel'
        })
        const fileName = params.types + ' ' + params.sos + ' ' + params.dtype + ' Report.xls'
        if ('download' in document.createElement('a')) {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          window.URL.revokeObjectURL(blob)
        } else {
          window.navigator.msSaveBlob(blob, fileName)
        }
      });
    },
    getMonitorConfig(ctx, params) {
      let url =
        `${baseMDReadiness}/monitor/` + params.owner
      http.get(url, {}).then(resp => {
        ctx.commit('setMonitorConfig', resp.data)
      });
    },
    getMonitorCode(ctx, params) {
      let url =
        `${baseMDReadiness}/monitorcode/` + params.owner
      http.get(url, {}).then(resp => {
        ctx.commit('setMonitorCode', resp.data)
      });
    },
    getMonitorReport(ctx, params) {
      let url =
        `${baseMDReadiness}/monitorreport/` + params.monitor + "/" + params.report_type;
      return http.get(url, {}).then(resp => {
        const blob = new Blob([resp.data], {
          type: 'application/vnd.ms-excel'
        })
        var fileName = 'Before Bulletin Report.xls'
        if(params.report_type == 'imdo'){
          fileName = 'Addtional SOS Report.xls'
        }
        if ('download' in document.createElement('a')) {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          window.URL.revokeObjectURL(blob)
        } else {
          window.navigator.msSaveBlob(blob, fileName)
        }
      });
    },
  },
  getters: {
    NIList(state) {
      return state.check_list.filter((ele) => ele["product_nature_2"] === "New Item" || ele["product_nature_2"] === "New Initiative")
    },
    SoftConversionList(state) {
      return state.check_list.filter((ele) => ele["product_nature_2"] === "Soft Conversion")
    },
    HardConersionList(state) {
      return state.check_list.filter((ele) => ele["product_nature_2"] === "Hard Conversion")
    },
    OtherList(state) {
      return state.check_list.filter((ele) => ele["product_nature_2"] !== "New Item" && ele["product_nature_2"] !== "New Initiative" &&
        ele["product_nature_2"] !== "Soft Conversion" && ele["product_nature_2"] !== "Hard Conversion")
    }
  },
  modules: {}
}



// WEBPACK FOOTER //
// ./src/store/dashboard.js